import {useAppSelector} from "../store/store";
import {Navigate} from "react-router-dom";


export const AuthComponents = ({children}) => {
    const {isAuth} = useAppSelector((state) => state.auth);
    console.log(isAuth);
    return isAuth ? (children) : <Navigate to={'/login'}/>
}